import "../../index23.css";
import { jsxs as i, jsx as e, Fragment as k } from "react/jsx-runtime";
import { useRef as f, useState as y, useEffect as A, useCallback as m, useMemo as E } from "react";
import { ArrowUpSmallFillIcon as F, ArrowDownSmallFillIcon as W } from "@ifrc-go/icons";
import { _ as u } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import U from "../Button/index.js";
import q from "../Popup/index.js";
import z from "../../contexts/dropdown-menu.js";
import G from "../../hooks/useBlurEffect.js";
const H = "_dropdown-menu_3j5nc_1", J = "_dropdown-icon_3j5nc_8", K = "_dropdown-content_3j5nc_14", t = {
  dropdownMenu: H,
  dropdownIcon: J,
  dropdownContent: K
};
function eo(w) {
  const h = f(null), {
    className: C,
    activeClassName: b,
    children: _,
    label: R,
    labelBefore: I,
    labelAfter: d,
    labelSpacing: M,
    labelColorVariant: N,
    labelStyleVariant: D,
    labelWithoutPadding: S,
    withoutDropdownIcon: s,
    componentRef: r,
    elementRef: l = h,
    persistent: c,
    popupClassName: g,
    preferredPopupWidth: j
  } = w, p = f(null), [n, o] = y(!1);
  A(() => {
    r && (r.current = {
      setShowDropdown: o
    });
  }, [r, o]);
  const v = m(
    () => {
      o((a) => !a);
    },
    [o]
  ), x = m(
    (a, V) => {
      V || a && c || o(!1);
    },
    [o, c]
  );
  G(
    n,
    x,
    p,
    l
  );
  const B = E(
    () => ({
      setShowDropdown: o
    }),
    [o]
  ), P = !!d || !s;
  return /* @__PURE__ */ i(z.Provider, { value: B, children: [
    /* @__PURE__ */ e(
      U,
      {
        name: void 0,
        className: u(
          t.dropdownMenu,
          n && b,
          C
        ),
        layoutElementRef: l,
        onClick: v,
        styleVariant: D,
        colorVariant: N,
        withoutPadding: S,
        spacing: M,
        after: P ? /* @__PURE__ */ i(k, { children: [
          d,
          !s && (n ? /* @__PURE__ */ e(F, { className: t.dropdownIcon }) : /* @__PURE__ */ e(W, { className: t.dropdownIcon }))
        ] }) : void 0,
        before: I,
        children: R
      }
    ),
    n && /* @__PURE__ */ e(
      q,
      {
        elementRef: p,
        className: u(t.dropdownContent, g),
        parentRef: l,
        preferredWidth: j,
        children: _
      }
    )
  ] });
}
export {
  eo as default
};
